//@flow
import React, { Component } from 'react';
import {
  FiltersDiv,
  FiltersSectionDiv,
  CustomCalendarFilter
} from './CommissionPaidIndex/CommissionPaidIndexStyles';
import TableFilter from '../../components/TableFilter';
import { filterOptions } from '../../utilities/filters';
import { Default } from '../../components/Responsive';
import CsvFilter from '../../components/CsvFilter';

export type PaidFiltersProps = {|
  statusFilter: ?string,
  setStatusFilter: (value: ?string | number) => void,
  toggleCalendarFilter: () => void,
  calendarFilterState: boolean,
  calendarStart: string,
  calendarEnd: string,
  clearCalendarFilter: () => void,
  setCalendarStartFilter: (date: ?moment$Moment) => void,
  setCalendarEndFilter: (date: ?moment$Moment) => void,
  windowSize: string,
  setCalendarSaga: () => void,
  availableFilters: {
    type: string[],
    status: string[]
  },
  disabled?: boolean,
  downloadPaidCsv: () => void,
  availableFilters: { status: Array<string> }
|};

class PaidFilters extends Component<PaidFiltersProps> {
  renderStatusFilter = (rightEnd: boolean = false) => (
    <TableFilter
      value={this.props.statusFilter}
      onChange={this.props.setStatusFilter}
      options={filterOptions(this.props.availableFilters.status)}
      label="Status"
      rightEnd={rightEnd}
      noMaxWidth
      disabled={this.props.disabled}
    />
  );

  renderDateFilter = () => (
    <CustomCalendarFilter
      toggleCalendarFilter={this.props.toggleCalendarFilter}
      calendarFilterState={this.props.calendarFilterState}
      calendarStart={this.props.calendarStart}
      calendarEnd={this.props.calendarEnd}
      clearCalendarFilter={this.props.clearCalendarFilter}
      setCalendarStartFilter={this.props.setCalendarStartFilter}
      setCalendarEndFilter={this.props.setCalendarEndFilter}
      windowSize={this.props.windowSize}
      setCalendarSaga={this.props.setCalendarSaga}
      disabled={this.props.disabled}
    />
  );

  renderCsvFilter = () => (
    <CsvFilter
      rightEnd
      filterRow
      handleCsvFilter={this.props.downloadPaidCsv}
      disabled={this.props.disabled}
    />
  );

  render() {
    return (
      <FiltersDiv>
        <FiltersSectionDiv>
          {this.renderStatusFilter()}
          {this.renderDateFilter()}
          <Default>{this.renderCsvFilter()}</Default>
        </FiltersSectionDiv>
      </FiltersDiv>
    );
  }
}

export default PaidFilters;
